import { CloudCheck } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgCloudCheck = mkIcon(CloudCheck);
